module.exports = __webpack_public_path__ + "static/media/nl.739a913d.svg";